import { RemoveProductFromWishListRequest } from '../interfaces/wish-list-update-product.interface';
import { getAuthenticationHeaders } from '../../../common/utils/auth-utils';
import { getRemoveProductFromWishlistsMagento } from '../../../common/constants/shop-api';
import { getResponseData } from '../../../common/utils/api-utils';

export async function getRemoveProductFromWishlistsApiCallMagento(
  request: RemoveProductFromWishListRequest
): Promise<any> {
  const url = getRemoveProductFromWishlistsMagento(request.wishListId, request.wishListItemId);

  return await getResponseData(
    new Request(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: getAuthenticationHeaders(),
    })
  );
}
